/**
 * Initials for an avatar with no image.
 *
 * First letter of the first word plus first letter of the last, so
 * "Priya Nair" gives "PN" and a single-word name still gives one letter rather
 * than an empty circle. Falls back to "?" rather than throwing, because a
 * display name is server-supplied and can be anything.
 */
export function deriveInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
